import React, {useEffect} from 'react';
import { makeStyles,  withStyles } from '@material-ui/core/styles';
import { TableCell, TableRow } from '@material-ui/core';

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: 'white',
    borderBottom: '2px solid rgb(201,201,201,1)'
  }  
}))(TableRow);

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    }
  }
});

export default function Row(props) {
  const { row, index } = props;
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <StyledTableRow className={classes.root}>
        <TableCell component="th" scope="row" ><h4>{row.airline}</h4></TableCell>
        <TableCell >{row.flightNum}</TableCell>
        <TableCell >{row.aircraftModel}</TableCell>
        <TableCell >{row.departure}</TableCell>
        <TableCell >{row.depDate}</TableCell>
        <TableCell >{row.arrival}</TableCell>
        <TableCell >{row.status}</TableCell>
      </StyledTableRow>
    </React.Fragment>
  );
}